import { render, staticRenderFns } from "./QuestionnaireView.vue?vue&type=template&id=568b6477&scoped=true"
import script from "./QuestionnaireView.vue?vue&type=script&lang=js"
export * from "./QuestionnaireView.vue?vue&type=script&lang=js"
import style0 from "./QuestionnaireView.vue?vue&type=style&index=0&id=568b6477&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "568b6477",
  null
  
)

export default component.exports